import { RbacMe } from '../models/rbac.model';

const ADMINISTRATION_ITEMS = [
  { title: 'People', url: '/people', module: ['admin', 'users'], permission: 'users.user.view', icon: 'user.png', openedImage: 'user.png' },
  { title: 'Company', url: '/company', module: ['admin', 'departments'], permission: 'admin.company.view', icon: 'enterprise.png', openedImage: 'enterprise.png' },
  { title: 'Departments', url: '/departments', module: ['admin', 'departments'], icon: 'departments.png', openedImage: 'departments.png' },
  { title: 'Approvers', url: '/approvers', module: ['admin'], permission: 'approvals.approver.view', icon: 'Travel-Management_unselect.png', openedImage: 'Travel-Management-select.png' },
  { title: 'Manage Proxies', url: '/proxies', module: ['admin', 'proxies'], icon: 'proxy.png', openedImage: 'proxy.png' },
  { title: 'Travel Policy', url: '/travel-policy', module: ['admin', 'policies'], icon: 'Travel Management/travel policy.png', openedImage: 'Travel Management/travel policy.png' },
  { title: 'Reports', url: '/admin-reports', module: ['admin', 'reporting'], icon: 'file.png', openedImage: 'reports_select.png' },
];

const SUPER_ADMIN_ITEMS = [
  { title: 'Organisations', url: '/super-admin/organisations', module: ['*'], icon: 'enterprise.png', openedImage: 'enterprise.png' },
  { title: 'Module Access', url: '/super-admin/module-access', module: ['*'], icon: 'setting.png', openedImage: 'setting.png' },
  { title: 'Consolidated Report', url: '/super-admin/consolidated-report', module: ['*'], icon: 'file.png', openedImage: 'reports_select.png' },
];

function isModuleEnabled(rbac: RbacMe | null, module: string): boolean {
  if (module === '*') {
    return true;
  }
  if (!rbac) {
    return false;
  }
  // Module gating applies to every role, including super admin — enabled_modules
  // is the single source of truth for what's accessible for the org in session.
  return rbac.enabled_modules.includes(module);
}

function hasAllModules(rbac: RbacMe | null, modules: string[]): boolean {
  return modules.every(module => isModuleEnabled(rbac, module));
}

function hasPermission(rbac: RbacMe | null, permission?: string): boolean {
  if (!permission) {
    return true;
  }
  if (!rbac) {
    return false;
  }
  return rbac.is_super_admin || rbac.permissions.includes(permission);
}

function buildSubmenu(items: (typeof ADMINISTRATION_ITEMS[number] | typeof SUPER_ADMIN_ITEMS[number])[], rbac: RbacMe | null) {
  return items.map(item => ({
    ...item,
    menu_opened: false,
    disabled: !hasAllModules(rbac, item.module) || !hasPermission(rbac, (item as any).permission),
  }));
}

export function buildMenuList(rbac: RbacMe | null): any[] {
  const menuList: any[] = [
    {
      title: 'Home',
      url: '/home',
      icon: 'Icon.svg',
      menu_opened: false,
      openedImage: 'Home_select.png',
      showSubmenu: false,
    },
    {
      title: 'Booking',
      url: '/booking',
      icon: 'calender.png',
      menu_opened: false,
      openedImage: 'booking_select.png',
      showSubmenu: false,
    },
    {
      title: 'My Trips',
      url: '/booking/trips',
      icon: 'light.png',
      menu_opened: false,
      openedImage: 'airplane.svg',
      showSubmenu: false,
    },
  ];

  menuList.push({
    title: 'Approvals',
    url: '/booking/approvals',
    icon: 'Travel-Management_unselect.png',
    menu_opened: false,
    openedImage: 'Travel-Management-select.png',
    showSubmenu: false,
    disabled: !isModuleEnabled(rbac, 'approvals'),
  });

  const isCompanyAdmin = (!!rbac?.is_super_admin || !!rbac?.roles.includes('company_admin')) &&
    isModuleEnabled(rbac, 'admin');
  const isSuperAdmin = !!rbac?.is_super_admin;

  if (isCompanyAdmin) {
    menuList.push({
      title: 'Company Admin',
      url: null,
      icon: 'person.png',
      menu_opened: false,
      openedImage: 'people_select.png',
      showSubmenu: false,
      submenu: buildSubmenu(ADMINISTRATION_ITEMS, rbac),
    });
  }

  if (isSuperAdmin) {
    menuList.push({
      title: 'Super Admin',
      url: null,
      icon: 'person.png',
      menu_opened: false,
      openedImage: 'people_select.png',
      showSubmenu: false,
      submenu: buildSubmenu(SUPER_ADMIN_ITEMS, rbac),
    });
  }

  menuList.push({
    title: 'My Profile',
    url: '/userprofile',
    icon: 'profile.svg',
    menu_opened: false,
    openedImage: 'profile.svg',
    showSubmenu: false,
  });

  return menuList;
}
